'use client'

import { createContext, useContext, useMemo } from 'react'
import { BLOCK_PRESENTATION } from './constants'
import { useInRichTextCanvas } from './RichTextCanvasContext'

const BlockPresentationContext = createContext(BLOCK_PRESENTATION.STANDALONE)

export function BlockPresentationProvider({ mode, children }) {
  const value = useMemo(
    () =>
      mode === BLOCK_PRESENTATION.EMBEDDED
        ? BLOCK_PRESENTATION.EMBEDDED
        : BLOCK_PRESENTATION.STANDALONE,
    [mode],
  )

  return (
    <BlockPresentationContext.Provider value={value}>
      {children}
    </BlockPresentationContext.Provider>
  )
}

export function useBlockPresentation() {
  return useContext(BlockPresentationContext)
}

export function useIsStandaloneBlock() {
  const inRichText = useInRichTextCanvas()
  if (inRichText) return false
  return useBlockPresentation() === BLOCK_PRESENTATION.STANDALONE
}

export function useIsEmbeddedBlock() {
  return !useIsStandaloneBlock()
}
